import api, { authenticatedApi } from "../utils/api";

const BASE = "/api/weekly-log";

export async function getWeeklyLog(
  token: string | null,
  studyId: string,
  startDate: string,
  endDate: string
) {
  const params = new URLSearchParams({
    studyId,
    startDate,
    endDate,
  }).toString();
  if (token) return authenticatedApi.get(`${BASE}?${params}`, token);
  return api.get(`${BASE}?${params}`);
}

export async function saveWeeklyLog(token: string | null, payload: any) {
  if (!token) return api.post(BASE, payload);
  return authenticatedApi.post(BASE, payload, token);
}

export const WeeklyLogService = { getWeeklyLog, saveWeeklyLog };
